import { defineStore } from 'pinia';
import { useListStorageAreas, type ListStorageAreaResponse } from '../api/listStorageAreas';
import { useStorageAreaStore } from 'shared/storageAreas/stores/storageAreaStore';
import { useRefreshStore } from '@/common/composables/refreshStore';

export const useRefreshStorageAreaStore = defineStore('refresh-storage-areas', () => {
  const listStorageArea = useListStorageAreas();
  const store = useStorageAreaStore();

  return useRefreshStore<ListStorageAreaResponse>({
    fetchFromServer() {
      return listStorageArea.execute();
    },

    mergeToStore(response) {
      store.clear();
      store.merge(response.storageAreas);
    },
  });
});
